const URL = 'https://back-juliana-muzz.onrender.com'
// const URL = 'http://localhost:3030'
export default URL;